import {combineReducers} from 'redux'
import {createPivotTableReducer} from 'reducers/pivotTable'
import Immutable from 'seamless-immutable'
import types from 'actions/types'
import {get} from 'lodash'
import {QuoteStatus} from 'helpers/quotes'

export const isVisible = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG:
      return true
    case types.HIDE_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG:
      return false
    default:
      return state
  }
}

export const type = (state = Immutable(-1), action) => {
  switch (action.type) {
    case types.PURCHASING_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG_UPDATE_FILTERS:
      return get(action, 'filters.type', state)
    default:
      return state
  }
}

export const creatorId = (state = null, action) => {
  switch (action.type) {
    case types.PURCHASING_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG_UPDATE_FILTERS:
      return get(action, 'filters.creatorId', state)
    default:
      return state
  }
}

export const salesmanId = (state = null, action) => {
  switch (action.type) {
    case types.PURCHASING_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG_UPDATE_FILTERS:
      return get(action, 'filters.salesmanId', state)
    default:
      return state
  }
}

export const estimatorId = (state = null, action) => {
  switch (action.type) {
    case types.PURCHASING_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG_UPDATE_FILTERS:
      return get(action, 'filters.estimatorId', state)
    default:
      return state
  }
}

export const timeKey = (state = Immutable('custom:'), action) => {
  switch (action.type) {
    case types.PURCHASING_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG_UPDATE_FILTERS:
      return get(action, 'filters.timeKey', state)
    default:
      return state
  }
}

export const allRevisions = (state = Immutable(false), action) => {
  switch (action.type) {
    case types.PURCHASING_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG_UPDATE_FILTERS:
      return get(action, 'filters.allRevisions', state)
    default:
      return state
  }
}

export const selectedOrderId = (state = null, action) => {
  switch (action.type) {
    case types.PURCHASING_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG_SELECT_QUOTE:
      return action.orderId
    case types.SHOW_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG:
      return null
    case types.HIDE_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG:
      return null
    default:
      return state
  }
}

export const statusTypes = (state = [QuoteStatus.confirmed], action) => {
  switch (action.type) {
    case types.PURCHASING_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG_UPDATE_FILTERS:
      return get(action, 'filters.statusTypes', state)
    default:
      return state
  }
}

export const companies = (state = [], action) => {
  switch (action.type) {
    case types.PURCHASING_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG_UPDATE_FILTERS:
      return get(action, 'filters.companies', state)
    default:
      return state
  }
}

export const userTypes = (state = [], action) => {
  switch (action.type) {
    case types.PURCHASING_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG_UPDATE_FILTERS:
      return get(action, 'filters.userTypes', state)
    default:
      return state
  }
}

export const contacts = (state = [], action) => {
  switch (action.type) {
    case types.PURCHASING_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG_UPDATE_FILTERS:
      return get(action, 'filters.contacts', state)
    default:
      return state
  }
}

export const dateTypes = (state = [], action) => {
  switch (action.type) {
    case types.PURCHASING_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG_UPDATE_FILTERS:
      return get(action, 'filters.dateTypes', state)
    default:
      return state
  }
}

export const targetStart = (state = null, action) => {
  switch (action.type) {
    case types.PURCHASING_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG_UPDATE_FILTERS:
      return get(action, 'filters.targetStart', state)
    default:
      return state
  }
}

export const targetEnd = (state = null, action) => {
  switch (action.type) {
    case types.PURCHASING_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG_UPDATE_FILTERS:
      return get(action, 'filters.targetEnd', state)
    default:
      return state
  }
}

export const isSaving = (state = false, action) => {
  switch (action.type) {
    case types.PURCHASING_PURCHASE_ORDER_ADD_ITEMS:
      return true
    case types.PURCHASING_PURCHASE_ORDER_SAVE_SUCCESS:
      return false
    default: return state
  }
}

export const orderItems = (state = [], action) => {
  switch (action.type) {
    case types.PIVOT_TABLE_LOAD_SUCCESS:
      return action.key === addItemsToPurchaseOrderDialogItemsPivotTableKey
        ? action.data
        : state

    default:
      return state
  }
}

export const addItemsToPurchaseOrderDialogOrdersPivotTableKey = 'dialogs.addItemsToPurchaseOrder.orders'
export const addItemsToPurchaseOrderDialogItemsPivotTableKey = 'dialogs.addItemsToPurchaseOrder.items'
export const addItemsToPurchaseOrderDialogChosenItemsPivotTableKey = 'dialogs.addItemsToPurchaseOrder.chosenItems'

export default combineReducers({
  isVisible,
  type,
  creatorId,
  salesmanId,
  estimatorId,
  timeKey,
  allRevisions,
  selectedOrderId,
  statusTypes,
  companies,
  userTypes,
  contacts,
  dateTypes,
  targetStart,
  targetEnd,
  isSaving,
  orderItems,
  orders: createPivotTableReducer({key: addItemsToPurchaseOrderDialogOrdersPivotTableKey, defaultSortColumn: 'createdDate',defaultSortDirection: 'desc'}),
  items: createPivotTableReducer({key: addItemsToPurchaseOrderDialogItemsPivotTableKey, defaultSortColumn: Immutable('itemId'),defaultSortDirection: Immutable('asc'),pageSize: 1000}),
  chosenItems: createPivotTableReducer({key: addItemsToPurchaseOrderDialogChosenItemsPivotTableKey, defaultSortColumn: 'itemId', defaultSortDirection: 'desc', pageSize: 1000}),
})
